'use strict';

(function () {
    const section = document.querySelector(".nnr-clean");

    if (!section || section.dataset.ready === "true") return;

    section.dataset.ready = "true";

    const track = section.querySelector(".nnr-clean-track");
    const previousButton = section.querySelector(".nnr-clean-prev");
    const nextButton = section.querySelector(".nnr-clean-next");
    const videos = section.querySelectorAll(".nnr-clean-video");

    function getScrollAmount() {
      const card = track.querySelector(".nnr-clean-card");

      if (!card) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(
        styles.columnGap ||
        styles.gap ||
        17
      );

      return card.getBoundingClientRect().width + gap;
    }

    if (previousButton) {
      previousButton.addEventListener("click", function () {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: "smooth"
        });
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: "smooth"
        });
      });
    }

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const video = entry.target;

            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        {
          rootMargin: "120px 0px",
          threshold: 0.15
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }
  })();

(function () {
    const block = document.querySelector(".nn-four");

    if (!block || block.dataset.ready === "true") return;

    block.dataset.ready = "true";

    const videos = block.querySelectorAll(".nn-four-observed-video");

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const video = entry.target;

            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        {
          rootMargin: "160px 0px",
          threshold: 0.08
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }
  })();

(function () {
    const block = document.querySelector(".nn-five");

    if (!block || block.dataset.ready === "true") return;

    block.dataset.ready = "true";

    const videos = block.querySelectorAll(".nn-five-observed-video");

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const video = entry.target;

            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        {
          rootMargin: "160px 0px",
          threshold: 0.08
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }
  })();
